var _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSirenIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_485_74630",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 71,
    height: 71
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 70,
    height: 70,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_485_74630)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36,
    cy: 51.0625,
    rx: 30,
    ry: 12.1875,
    fill: "url(#paint0_radial_485_74630)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8643 47.5713V52.4172C15.8643 55.863 24.8118 58.6574 35.8513 58.6574C46.8909 58.6574 55.8384 55.863 55.8384 52.4172V47.5713H15.8643Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M15.8643 47.5713V52.4172C15.8643 55.863 24.8118 58.6574 35.8513 58.6574C46.8909 58.6574 55.8384 55.863 55.8384 52.4172V47.5713H15.8643Z",
    fill: "url(#paint1_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M15.8643 47.5713V52.4172C15.8643 55.863 24.8118 58.6574 35.8513 58.6574C46.8909 58.6574 55.8384 55.863 55.8384 52.4172V47.5713H15.8643Z",
    fill: "url(#paint2_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M15.8643 47.5713V52.4172C15.8643 55.863 24.8118 58.6574 35.8513 58.6574C46.8909 58.6574 55.8384 55.863 55.8384 52.4172V47.5713H15.8643Z",
    fill: "url(#paint3_radial_485_74630)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8513 53.8113C46.8899 53.8113 55.8384 51.0175 55.8384 47.5712C55.8384 44.1249 46.8899 41.3311 35.8513 41.3311C24.8128 41.3311 15.8643 44.1249 15.8643 47.5712C15.8643 51.0175 24.8128 53.8113 35.8513 53.8113Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.8513 53.8113C46.8899 53.8113 55.8384 51.0175 55.8384 47.5712C55.8384 44.1249 46.8899 41.3311 35.8513 41.3311C24.8128 41.3311 15.8643 44.1249 15.8643 47.5712C15.8643 51.0175 24.8128 53.8113 35.8513 53.8113Z",
    fill: "url(#paint4_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M35.8513 53.8113C46.8899 53.8113 55.8384 51.0175 55.8384 47.5712C55.8384 44.1249 46.8899 41.3311 35.8513 41.3311C24.8128 41.3311 15.8643 44.1249 15.8643 47.5712C15.8643 51.0175 24.8128 53.8113 35.8513 53.8113Z",
    fill: "url(#paint5_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M35.8513 53.8113C46.8899 53.8113 55.8384 51.0175 55.8384 47.5712C55.8384 44.1249 46.8899 41.3311 35.8513 41.3311C24.8128 41.3311 15.8643 44.1249 15.8643 47.5712C15.8643 51.0175 24.8128 53.8113 35.8513 53.8113Z",
    fill: "url(#paint6_radial_485_74630)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8284 40.5391V46.479C16.8284 49.7597 25.3452 52.4175 35.8504 52.4175C46.3557 52.4175 54.8725 49.7582 54.8725 46.479V40.5391H16.8284Z",
    fill: "#B01D00"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M16.8284 40.5391V46.479C16.8284 49.7597 25.3452 52.4175 35.8504 52.4175C46.3557 52.4175 54.8725 49.7582 54.8725 46.479V40.5391H16.8284Z",
    fill: "url(#paint7_linear_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8,
    d: "M16.8284 40.5391V46.479C16.8284 49.7597 25.3452 52.4175 35.8504 52.4175C46.3557 52.4175 54.8725 49.7582 54.8725 46.479V40.5391H16.8284Z",
    fill: "url(#paint8_linear_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M16.8284 40.5391V46.479C16.8284 49.7597 25.3452 52.4175 35.8504 52.4175C46.3557 52.4175 54.8725 49.7582 54.8725 46.479V40.5391H16.8284Z",
    fill: "url(#paint9_radial_485_74630)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8517 46.8734C25.2414 46.8734 16.9287 44.154 16.9287 40.6828C16.9287 37.2116 25.2414 34.4922 35.8517 34.4922C46.4621 34.4922 54.7747 37.2116 54.7747 40.6828C54.7747 44.154 46.4621 46.8734 35.8517 46.8734ZM35.8517 34.8914C30.8707 34.8914 26.1899 35.5112 22.6721 36.6368C19.2744 37.7233 17.3264 39.1986 17.3264 40.6828C17.3264 42.167 19.2744 43.6423 22.6721 44.7288C26.1899 45.8544 30.8692 46.4742 35.8517 46.4742C40.8342 46.4742 45.5136 45.8544 49.0314 44.7288C52.4291 43.6423 54.377 42.167 54.377 40.6828C54.377 39.1986 52.4291 37.7233 49.0314 36.6368C45.5136 35.5112 40.8342 34.8914 35.8517 34.8914Z",
    fill: "#F05E41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8519 46.4776C46.3575 46.4776 54.874 43.8188 54.874 40.5391C54.874 37.2593 46.3575 34.6006 35.8519 34.6006C25.3463 34.6006 16.8298 37.2593 16.8298 40.5391C16.8298 43.8188 25.3463 46.4776 35.8519 46.4776Z",
    fill: "#C42100"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M35.8519 46.4776C46.3575 46.4776 54.874 43.8188 54.874 40.5391C54.874 37.2593 46.3575 34.6006 35.8519 34.6006C25.3463 34.6006 16.8298 37.2593 16.8298 40.5391C16.8298 43.8188 25.3463 46.4776 35.8519 46.4776Z",
    fill: "url(#paint10_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M35.8519 46.4776C46.3575 46.4776 54.874 43.8188 54.874 40.5391C54.874 37.2593 46.3575 34.6006 35.8519 34.6006C25.3463 34.6006 16.8298 37.2593 16.8298 40.5391C16.8298 43.8188 25.3463 46.4776 35.8519 46.4776Z",
    fill: "url(#paint11_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M35.8519 46.4776C46.3575 46.4776 54.874 43.8188 54.874 40.5391C54.874 37.2593 46.3575 34.6006 35.8519 34.6006C25.3463 34.6006 16.8298 37.2593 16.8298 40.5391C16.8298 43.8188 25.3463 46.4776 35.8519 46.4776Z",
    fill: "url(#paint12_radial_485_74630)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8521 7C26.0807 7 18.1582 8.68535 18.1582 10.7624V38.2547C18.1582 41.3057 26.0792 43.779 35.8521 43.779C45.625 43.779 53.546 41.3057 53.546 38.2547V10.7624C53.546 8.68385 45.625 7 35.8521 7Z",
    fill: "#CC2200"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M35.8521 7C26.0807 7 18.1582 8.68535 18.1582 10.7624V38.2547C18.1582 41.3057 26.0792 43.779 35.8521 43.779C45.625 43.779 53.546 41.3057 53.546 38.2547V10.7624C53.546 8.68385 45.625 7 35.8521 7Z",
    fill: "url(#paint13_linear_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8,
    d: "M35.8521 7C26.0807 7 18.1582 8.68535 18.1582 10.7624V38.2547C18.1582 41.3057 26.0792 43.779 35.8521 43.779C45.625 43.779 53.546 41.3057 53.546 38.2547V10.7624C53.546 8.68385 45.625 7 35.8521 7Z",
    fill: "url(#paint14_linear_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M35.8519 14.6866C45.3761 14.6866 53.097 13.078 53.097 11.0938C53.097 9.10953 45.3761 7.50098 35.8519 7.50098C26.3276 7.50098 18.6067 9.10953 18.6067 11.0938C18.6067 13.078 26.3276 14.6866 35.8519 14.6866Z",
    fill: "url(#paint15_linear_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M35.8519 14.6866C45.3761 14.6866 53.097 13.078 53.097 11.0938C53.097 9.10953 45.3761 7.50098 35.8519 7.50098C26.3276 7.50098 18.6067 9.10953 18.6067 11.0938C18.6067 13.078 26.3276 14.6866 35.8519 14.6866Z",
    fill: "url(#paint16_linear_485_74630)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8518 14.8866C27.2764 14.8866 18.407 13.4684 18.407 11.0942C18.407 8.71997 27.2764 7.30176 35.8518 7.30176C44.4271 7.30176 53.2965 8.71997 53.2965 11.0942C53.2965 13.4684 44.4271 14.8866 35.8518 14.8866ZM35.8518 7.69946C25.6556 7.69946 18.8062 9.45384 18.8062 11.0942C18.8062 12.7345 25.6556 14.4889 35.8518 14.4889C46.0479 14.4889 52.8973 12.7345 52.8973 11.0942C52.8973 9.45384 46.0479 7.69946 35.8518 7.69946Z",
    fill: "url(#paint17_radial_485_74630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.8517 34.5986C27.8212 34.5986 20.9523 36.1519 18.1624 38.3505C18.3244 41.358 26.1824 43.7803 35.8517 43.7803C45.5211 43.7803 53.3791 41.358 53.5411 38.3505C50.7512 36.1534 43.8823 34.5986 35.8517 34.5986Z",
    fill: "url(#paint18_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.8517 34.5986C27.8212 34.5986 20.9523 36.1519 18.1624 38.3505C18.3244 41.358 26.1824 43.7803 35.8517 43.7803C45.5211 43.7803 53.3791 41.358 53.5411 38.3505C50.7512 36.1534 43.8823 34.5986 35.8517 34.5986Z",
    fill: "url(#paint19_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.8517 34.5986C27.8212 34.5986 20.9523 36.1519 18.1624 38.3505C18.3244 41.358 26.1824 43.7803 35.8517 43.7803C45.5211 43.7803 53.3791 41.358 53.5411 38.3505C50.7512 36.1534 43.8823 34.5986 35.8517 34.5986Z",
    fill: "url(#paint20_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M35.8517 43.0926C26.4765 43.0926 18.8062 40.9871 18.1984 38.3232C18.1864 38.3322 18.1729 38.3413 18.1624 38.3503C18.3244 41.3578 26.1824 43.78 35.8517 43.78C45.5211 43.78 53.3791 41.3578 53.5411 38.3503C53.5291 38.3413 53.5156 38.3322 53.5051 38.3232C52.8973 40.9871 45.227 43.0926 35.8517 43.0926Z",
    fill: "url(#paint21_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7378 39.9132C18.3891 36.8456 18.5272 33.2123 18.1565 29.585V38.2563C18.1565 39.7481 20.0519 41.1018 23.1315 42.0968C22.2145 41.5145 21.3966 40.7761 20.7363 39.9132H20.7378Z",
    fill: "#C22000"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5451 38.2561V32.5518C53.0168 32.8279 52.7662 33.5543 52.7422 34.114C52.7122 34.8149 52.9133 35.5052 52.9418 36.2061C52.9973 37.5853 52.3745 38.9225 51.4981 39.988C50.9803 40.6183 50.377 41.1661 49.7422 41.6793C52.1239 40.7384 53.5466 39.5498 53.5466 38.2576L53.5451 38.2561Z",
    fill: "#C22000"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.7765 30.0045C46.9426 24.6064 43.512 19.2851 38.1139 18.119C32.7158 16.9529 27.3945 20.3835 26.2284 25.7816C25.0623 31.1797 28.4929 36.501 33.891 37.6671C39.2891 38.8332 44.6104 35.4025 45.7765 30.0045Z",
    fill: "#FF765A"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M45.1317 29.988C46.2896 24.9448 43.1398 19.9178 38.0965 18.7599C33.0533 17.6021 28.0263 20.7518 26.8684 25.7951C25.7106 30.8384 28.8604 35.8654 33.9036 37.0232C38.9469 38.1811 43.9739 35.0313 45.1317 29.988Z",
    fill: "url(#paint22_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M45.1317 29.988C46.2896 24.9448 43.1398 19.9178 38.0965 18.7599C33.0533 17.6021 28.0263 20.7518 26.8684 25.7951C25.7106 30.8384 28.8604 35.8654 33.9036 37.0232C38.9469 38.1811 43.9739 35.0313 45.1317 29.988Z",
    fill: "url(#paint23_radial_485_74630)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4441 32.5762V39.0399C34.4441 39.2936 35.1014 39.4977 35.9118 39.4977C36.7222 39.4977 37.3796 39.2921 37.3796 39.0399V32.5762H34.4456H34.4441Z",
    fill: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M34.4441 32.5762V39.0399C34.4441 39.2936 35.1014 39.4977 35.9118 39.4977C36.7222 39.4977 37.3796 39.2921 37.3796 39.0399V32.5762H34.4456H34.4441Z",
    fill: "url(#paint24_linear_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M34.4441 32.5762V39.0399C34.4441 39.2936 35.1014 39.4977 35.9118 39.4977C36.7222 39.4977 37.3796 39.2921 37.3796 39.0399V32.5762H34.4456H34.4441Z",
    fill: "url(#paint25_linear_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M37.3781 32.5762V39.0399C37.3781 39.2936 36.7208 39.4977 35.9104 39.4977C35.1 39.4977 34.4426 39.2921 34.4426 39.0399V32.5762H37.3766H37.3781Z",
    fill: "url(#paint26_linear_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M37.3781 32.5762V39.0399C37.3781 39.2936 36.7208 39.4977 35.9104 39.4977C35.1 39.4977 34.4426 39.2921 34.4426 39.0399V32.5762H37.3766H37.3781Z",
    fill: "url(#paint27_linear_485_74630)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6104 24.4902V33.2036C31.6104 33.939 33.5193 34.5348 35.8725 34.5348C38.2257 34.5348 40.1347 33.939 40.1347 33.2036V24.4902H31.6089H31.6104Z",
    fill: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M31.6104 24.4902V33.2036C31.6104 33.939 33.5193 34.5348 35.8725 34.5348C38.2257 34.5348 40.1347 33.939 40.1347 33.2036V24.4902H31.6089H31.6104Z",
    fill: "url(#paint28_linear_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M40.1363 24.4902V33.2036C40.1363 33.939 38.2274 34.5348 35.8742 34.5348C33.521 34.5348 31.6121 33.939 31.6121 33.2036V24.4902H40.1378H40.1363Z",
    fill: "url(#paint29_linear_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M40.1363 24.4902V33.2036C40.1363 33.939 38.2274 34.5348 35.8742 34.5348C33.521 34.5348 31.6121 33.939 31.6121 33.2036V24.4902H40.1378H40.1363Z",
    fill: "url(#paint30_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M31.6104 24.4902V33.2036C31.6104 33.939 33.5193 34.5348 35.8725 34.5348C38.2257 34.5348 40.1347 33.939 40.1347 33.2036V24.4902H31.6089H31.6104Z",
    fill: "url(#paint31_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M31.6104 24.4902V33.2036C31.6104 33.939 33.5193 34.5348 35.8725 34.5348C38.2257 34.5348 40.1347 33.939 40.1347 33.2036V24.4902H31.6089H31.6104Z",
    fill: "url(#paint32_radial_485_74630)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8742 25.8205C38.2281 25.8205 40.1363 25.2246 40.1363 24.4894C40.1363 23.7542 38.2281 23.1582 35.8742 23.1582C33.5203 23.1582 31.6121 23.7542 31.6121 24.4894C31.6121 25.2246 33.5203 25.8205 35.8742 25.8205Z",
    fill: "#ADADAD"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M35.8742 25.8205C38.2281 25.8205 40.1363 25.2246 40.1363 24.4894C40.1363 23.7542 38.2281 23.1582 35.8742 23.1582C33.5203 23.1582 31.6121 23.7542 31.6121 24.4894C31.6121 25.2246 33.5203 25.8205 35.8742 25.8205Z",
    fill: "url(#paint33_radial_485_74630)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8857 26.6211H34.8612C34.5155 26.6211 34.2354 26.9013 34.2354 27.2469V32.7847C34.2354 33.1303 34.5155 33.4105 34.8612 33.4105H36.8857C37.2313 33.4105 37.5115 33.1303 37.5115 32.7847V27.2469C37.5115 26.9013 37.2313 26.6211 36.8857 26.6211Z",
    fill: "#FFCB00"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M36.8857 26.6211H34.8612C34.5155 26.6211 34.2354 26.9013 34.2354 27.2469V32.7847C34.2354 33.1303 34.5155 33.4105 34.8612 33.4105H36.8857C37.2313 33.4105 37.5115 33.1303 37.5115 32.7847V27.2469C37.5115 26.9013 37.2313 26.6211 36.8857 26.6211Z",
    fill: "url(#paint34_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M36.8857 26.6211H34.8612C34.5155 26.6211 34.2354 26.9013 34.2354 27.2469V32.7847C34.2354 33.1303 34.5155 33.4105 34.8612 33.4105H36.8857C37.2313 33.4105 37.5115 33.1303 37.5115 32.7847V27.2469C37.5115 26.9013 37.2313 26.6211 36.8857 26.6211Z",
    fill: "url(#paint35_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M36.8857 26.6211H34.8612C34.5155 26.6211 34.2354 26.9013 34.2354 27.2469V32.7847C34.2354 33.1303 34.5155 33.4105 34.8612 33.4105H36.8857C37.2313 33.4105 37.5115 33.1303 37.5115 32.7847V27.2469C37.5115 26.9013 37.2313 26.6211 36.8857 26.6211Z",
    fill: "url(#paint36_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M36.8857 26.6211H34.8612C34.5155 26.6211 34.2354 26.9013 34.2354 27.2469V32.7847C34.2354 33.1303 34.5155 33.4105 34.8612 33.4105H36.8857C37.2313 33.4105 37.5115 33.1303 37.5115 32.7847V27.2469C37.5115 26.9013 37.2313 26.6211 36.8857 26.6211Z",
    fill: "url(#paint37_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8,
    d: "M35.8521 7C26.0807 7 18.1582 8.68535 18.1582 10.7624V38.2547C18.1582 41.3057 26.0792 43.779 35.8521 43.779C45.625 43.779 53.546 41.3057 53.546 38.2547V10.7624C53.546 8.68385 45.625 7 35.8521 7Z",
    fill: "url(#paint38_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M35.8521 7C26.0807 7 18.1582 8.68535 18.1582 10.7624V38.2547C18.1582 41.3057 26.0792 43.779 35.8521 43.779C45.625 43.779 53.546 41.3057 53.546 38.2547V10.7624C53.546 8.68385 45.625 7 35.8521 7Z",
    fill: "url(#paint39_radial_485_74630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M35.8521 7C26.0807 7 18.1582 8.68535 18.1582 10.7624V38.2547C18.1582 41.3058 26.0792 43.779 35.8521 43.779C45.625 43.779 53.546 41.3058 53.546 38.2547V10.7624C53.546 8.68385 45.625 7 35.8521 7Z",
    fill: "url(#paint40_radial_485_74630)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.4375 14.0879C31.1928 14.2344 33.0849 14.3241 35.0625 14.3457V44.3516H29.4375V14.0879ZM51.9375 44.3516H46.3125V13.6582C48.6844 13.303 50.6248 12.8285 51.9375 12.2764V44.3516Z",
    fill: "url(#paint41_linear_485_74630)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 27.4775,
    r: 15,
    fill: "url(#paint42_radial_485_74630)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 27.625,
    r: 8.4375,
    fill: "url(#paint43_radial_485_74630)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36 51.0625) rotate(90) scale(10.3125 25.3846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7672 52.0225) scale(15.7129 15.7129)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#212121",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#212121",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.9691 51.8187) rotate(87.47) scale(13.5698 8.95608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#696969",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#535353",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#313131",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#212121",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.1469 54.1398) rotate(87.06) scale(17.4673 2.79477)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#606060",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#353535",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#212121",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9703 46.3406) scale(14.6279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#212121",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#212121",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5989 46.4732) rotate(47.17) scale(13.0491 9.39533)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#696969",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#535353",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#313131",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#212121",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.6785 52.7185) rotate(66.45) scale(12.839 2.69618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#696969",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#535353",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#313131",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#212121",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_485_74630",
    x1: 16.8284,
    y1: 46.4775,
    x2: 43.1891,
    y2: 46.4775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#691200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D92400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_485_74630",
    x1: 55.2072,
    y1: 46.4775,
    x2: 44.4257,
    y2: 46.4775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D92400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0467 49.332) rotate(90) scale(16.1496 4.3604)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDE6E1",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F9D0C8",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F2AD9F",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E97C66",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DD3E1E",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D92400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6617 39.364) scale(11.8154 11.8154)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#690000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D90000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.1101 39.2634) scale(11.3097 11.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D92400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.545 44.6881) rotate(67.21) scale(17.6939 5.83899)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D90000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_485_74630",
    x1: 17.9586,
    y1: 25.3902,
    x2: 21.3023,
    y2: 25.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#691200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D92400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_485_74630",
    x1: 54.1433,
    y1: 25.3902,
    x2: 49.0557,
    y2: 25.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D90000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_485_74630",
    x1: 18.6067,
    y1: 11.0938,
    x2: 53.097,
    y2: 11.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#691200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D92400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_485_74630",
    x1: 53.097,
    y1: 11.0938,
    x2: 18.6067,
    y2: 11.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D90000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.266 11.1527) scale(22.9946 22.9946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D90000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9178 39.4161) scale(22.2127 4.88679)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9E1A00",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#9E1A00",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#9E1A00",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#9E1A00",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9E1A00",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#9E1A00",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E1A00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9178 39.3301) scale(4.30416 1.20517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#731300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#741300",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#781400",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#801500",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8A1700",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#981900",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E1A00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8517 34.0971) scale(20.9505 6.07566)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#731300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#741300",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#781400",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#801500",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8A1700",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#981900",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E1A00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.1999 43.9842) scale(18.6199 2.79298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D90000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9998 27.8914) scale(9.36921)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF765A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FE7559",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FC7459",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F97358",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F47056",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EE6E54",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E76A51",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DE664E",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#D4624B",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#C95D47"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6518 24.5923) rotate(29.3) scale(6.43224 4.11663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFD9D1",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFD4CB",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFCBC0",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFBEB1",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFAE9E",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF9A86",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FF846B",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FF765A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_485_74630",
    x1: 35.9118,
    y1: 35.1124,
    x2: 35.9118,
    y2: 36.8818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#AFAFAF",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B2B2B2",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B8B8B8",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BFBFBF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C2C2C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_485_74630",
    x1: 34.3105,
    y1: 36.0369,
    x2: 35.1119,
    y2: 36.0369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#AFAFAF",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B2B2B2",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B8B8B8",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BFBFBF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C2C2C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_485_74630",
    x1: 37.5132,
    y1: 36.0369,
    x2: 36.7118,
    y2: 36.0369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#AFAFAF",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B2B2B2",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B8B8B8",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BFBFBF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C2C2C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_485_74630",
    x1: 35.9119,
    y1: 39.4631,
    x2: 35.9119,
    y2: 37.5992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#7E7E7E",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#919191",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#AEAEAE",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C2C2C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_485_74630",
    x1: 31.6104,
    y1: 29.5133,
    x2: 32.9791,
    y2: 29.5133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#AFAFAF",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B2B2B2",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B8B8B8",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BFBFBF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C2C2C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_485_74630",
    x1: 40.1363,
    y1: 29.5133,
    x2: 38.7692,
    y2: 29.5133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#AFAFAF",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B2B2B2",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B8B8B8",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BFBFBF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C2C2C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2183 29.7804) rotate(90) scale(10.897 1.19867)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E5E5E5",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6C6C6",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C2C2C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.0309 29.7789) rotate(90) scale(0.0750377 0.00825415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E5E5E5",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2D2D2",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6C6C6",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C2C2C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9326 25.3118) scale(4.3822 1.53377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FDFDFD",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F8F8F8",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F1F1F1",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E7E7E7",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#DADADA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#CBCBCB",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C2C2C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8477 24.4894) scale(4.85494 4.85494)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ADADAD",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ADADAD",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ADADAD",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ADADAD",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ADADAD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5294 30.2929) rotate(89.45) scale(3.12007 0.998422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2A121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5A321",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CEAB23",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#DEB825",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F3CA29",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD42B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9732 27.5841) scale(1.68835 0.320786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2A121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5A321",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CEAB23",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#DEB825",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F3CA29",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD42B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8677 31.0228) rotate(-90) scale(1.68835 0.320786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2A121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5A321",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CEAB23",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#DEB825",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F3CA29",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD42B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8937 30.0158) scale(4.5788 4.5788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFE068",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFDE60",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFDC54",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FFD843",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFD42E",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD42B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.1142 27.3022) rotate(90) scale(15.3587 2.76457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D90000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9022 24.4118) rotate(90) scale(20.0366 2.60475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D90000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9313 9.83496) rotate(1.67) scale(16.3522 2.77988)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D90000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_485_74630",
    x1: 40.6875,
    y1: 6.85192,
    x2: 40.6875,
    y2: 40.6016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36 27.4775) rotate(90) scale(15)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFF00",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEFF00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_485_74630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36 28.5625) rotate(90) scale(6.09375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSirenIco);
export default __webpack_public_path__ + "static/media/Siren_ico.c743e704c53747c01fc0a7ae05ddbd3c.svg";
export { ForwardRef as ReactComponent };